import { BaseFetchFn, FetcherMetaUpdate, FetchFn } from '@Types/fetcher'
import useBaseFetcher from '../base'
import { useCacheActions, useCacheState } from '@Store/slices/cache'
import { useEffect } from 'react'
import { MeMeta } from '@Types/me'

function useMe(): [FetchFn, MeMeta] {
  const [baseFetcher, meta, setMeta]: [
    baseFetcher: BaseFetchFn,
    meta: MeMeta,
    setMeta: FetcherMetaUpdate,
  ] = useBaseFetcher(true)

  const { me } = useCacheState()
  const { setMe } = useCacheActions()

  useEffect(() => {
    if (meta.isSuccess && meta.data) {
      setMe(meta.data)
    }
  }, [meta.isSuccess, meta.data])

  const meFetcher = async (useCachedValue = false) => {
    if (useCachedValue && me) {
      setMeta((prevMeta: typeof meta) => ({ ...prevMeta, data: me }))
      return
    }

    return await baseFetcher(`${import.meta.env.VITE_APP_URL}/users/me`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  return [meFetcher, meta]
}

export default useMe
